import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Button,
  DialogActions,
  useTheme,
} from '@mui/material';

import { i18n } from '../../translate/i18n';
import { getStyled } from './styles';

const DeleteAllConfirmationModal = ({
  confirmationOpen,
  setConfirmationOpen,
  CloseAllTicket,
}) => {
  const theme = useTheme();
  const classes = getStyled(theme);

  return (
    <Dialog
      open={confirmationOpen}
      onClose={() => setConfirmationOpen(false)}
      sx={classes.dialog}
      maxWidth='sm'
    >
      <DialogTitle id='confirm-dialog' sx={theme.custom.dialogColor}>
        Fechar Todos?
      </DialogTitle>

      <DialogContent dividers sx={theme.custom.dialogColor}>
        <Typography variant='subtitle1' gutterBottom>
          Deseja realmente fechar todos os tickets abertos?
        </Typography>
      </DialogContent>
      <DialogActions sx={theme.custom.dialogColor}>
        <Button
          onClick={() => setConfirmationOpen(!confirmationOpen)}
          variant='outlined'
          sx={theme.custom.cancelButton}
        >
          {i18n.t('messageOptionsMenu.confirmationModal.cancel')}
        </Button>
        <Button
          onClick={() => CloseAllTicket()}
          variant='outlined'
          sx={theme.custom.confirmButton}
        >
          {i18n.t('messageOptionsMenu.confirmationModal.okConfirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAllConfirmationModal;
